import { ServiceCompaniesSearchModel } from '../../models/service-companies/serviceCompaniesSearch';
import * as ServiceCompanyModels from '../../models/service-companies/serviceCompanies';

export class GetServiceCompaniesDictionary {
  static readonly type = 'GetServiceCompaniesDictionary';
  constructor() { }
}

export class GetServiceCompaniesList {
  static readonly type = 'GetServiceCompaniesList';
  constructor(public search: ServiceCompaniesSearchModel) { }
}

export class GetServiceCompaniesTypesDictionary {
  static readonly type = 'GetServiceCompaniesTypesDictionary';
  constructor() {}
}

export class SetServiceCompaniesSearch {
  static readonly type = 'SetServiceCompaniesSearch';
  constructor(public Search: ServiceCompaniesSearchModel) { }
}

export class SetServiceCompaniesListPage {
  static readonly type = 'SetServiceCompaniesListPage';
  constructor(public Search: ServiceCompaniesSearchModel) { }
}

export class ResetServiceCompaniesSearch {
  static readonly type = 'ResetServiceCompaniesSearch';
  constructor() { }
}

export class Insert {
  static readonly type = '[ServiceCompany] Insert';
  constructor(public ServiceCompany: ServiceCompanyModels.ServiceCompanyModel, public Version: number) {}
}

export class Get {
  static readonly type = '[ServiceCompany] Get';
  constructor(public ServiceCompanyId: number) {}
}

export class Set {
  static readonly type = '[ServiceCompany] Set';
  constructor(public ServiceCompany: ServiceCompanyModels.ServiceCompanyModel) { }
}

export class ResetSave {
  static readonly type = '[ServiceCompany] ResetSave';
  constructor() { }
}


export class GetFile {
  static readonly type = '[ServiceCompany] GetFile';
  constructor(public ServiceCompanyId: number, public FileType: string /* 'agreementFile' || 'otherFile' */, public FileName: string) { }
}


export class GetReportFiltered {
  static readonly type = '[ServiceCompany] GetReportFiltered';
  constructor(public Search: ServiceCompaniesSearchModel) { }
}

export class DisposeSearch {
  static readonly type = '[ServiceCompany] DisposeSearch';
  constructor() { }
}
